<div class="overflow-auto">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="reservedByUserName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Frátekið af</th>
            <td mat-cell *matCellDef="let row">{{ row.reservedByUserName }}</td>
        </ng-container>
        <ng-container matColumnDef="reservationTicketId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Azure DevOps miði</th>
            <td mat-cell *matCellDef="let row">{{ row.reservationTicketId }}</td>
        </ng-container>
        <ng-container matColumnDef="reservationStartTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Upphaf</th>
            <td mat-cell *matCellDef="let row">{{ row.reservationStartTime | date: 'dd.MM.yyyy HH:mm' }}</td>
        </ng-container>
        <ng-container matColumnDef="reservationEndTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Lok</th>
            <td mat-cell *matCellDef="let row">{{ row.reservationEndTime | date: 'dd.MM.yyyy HH:mm' }}</td>
        </ng-container>
        <ng-container matColumnDef="reason">
            <th mat-header-cell *matHeaderCellDef>Ástæða</th>
            <td mat-cell *matCellDef="let row">{{ row.reason }}</td>
        </ng-container>
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
                <button mat-icon-button type="button" (click)="delete(row.reservationId)" matTooltip="Eyða frátekt">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-secondary py-4 px-6" [attr.colspan]="tableColumns.length">
                Engar frátektir skráðar fyrir {{ selectedEnvironment | uppercase }}
            </td>
        </tr>
    </table>
    <mat-paginator #tablePaginator [pageSizeOptions]="[10, 25, 50]" [pageSize]="25"></mat-paginator>
</div>
